import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { SxProps, Theme } from "@mui/material/styles";

import { truncate } from "lodash";

type CreatedByBlockProps = {
  creator?: string;
  createdDate?: string;
  updatedBy?: string;
  lastUpdateDate?: string;
  containerSx?: SxProps<Theme>;
  labelSx?: SxProps<Theme>;
  valueSx?: SxProps<Theme>;
};

const MAX_NAME_LENGTH = 25;

export default function CreatedByBlock({
  creator,
  createdDate,
  updatedBy,
  lastUpdateDate,
  containerSx,
  labelSx,
  valueSx
}: CreatedByBlockProps) {
  const createdValue = creator
    ? `${truncate(creator, {
        separator: "…",
        length: MAX_NAME_LENGTH
      })} at: ${createdDate}`
    : `${createdDate}`;

  const updatedValue = updatedBy
    ? `${truncate(updatedBy, {
        separator: "…",
        length: MAX_NAME_LENGTH
      })} at: ${lastUpdateDate}`
    : `${lastUpdateDate}`;

  const defaultContainerSx: SxProps<Theme> = {
    mt: -5.5,
    ml: 0,
    mb: 2,
    height: "34px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  };

  const defaultLabelSx: SxProps<Theme> = {
    color: grey[600],
    fontSize: "12px",
    width: "94px"
  };

  const defaultValueSx: SxProps<Theme> = {
    color: grey[600],
    fontSize: "12px",
    lineHeight: 1.1,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: "2",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    width: "calc(100% - 230px)"
  };

  return (
    <Box
      sx={{
        ...defaultContainerSx,
        ...containerSx
      }}
    >
      {createdDate && (
        <Stack direction="row">
          <Typography
            sx={{
              ...defaultLabelSx,
              ...labelSx
            }}
          >
            Created:
          </Typography>
          <Typography
            sx={{
              ...defaultValueSx,
              ...valueSx
            }}
          >
            {createdValue}
          </Typography>
        </Stack>
      )}
      {lastUpdateDate && (
        <Stack direction="row" mt={0.5}>
          <Typography
            sx={{
              ...defaultLabelSx,
              ...labelSx
            }}
          >
            Last&nbsp;updated:
          </Typography>

          <Typography
            sx={{
              ...defaultValueSx,
              ...valueSx
            }}
          >
            {updatedValue}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}
